import { useGetWorkflowStateEvents } from '@/service-library/hooks/workflow-state-events'
import { getWorkflowStateEventGroups } from '@/utils/workflow-state-events'
import { useWorkflowStatePageContext } from '@/components/workflow-state-page/WorkflowStatePage'

export default function useGetEventsForWorkflowState() {
  const { workflowState } = useWorkflowStatePageContext()
  const {
    workflowStateEvents = [],
    isPending,
    queryKey,
  } = useGetWorkflowStateEvents({
    filters: {
      limit: '1000',
      workflow_state_id: workflowState.id,
      fields__include: 'actions',
      actions__fields__include: 'action_type',
    },
  })

  const { systemEvents, customEvents } =
    getWorkflowStateEventGroups(workflowStateEvents)

  return {
    systemEvents,
    customEvents,
    isPending,
    queryKey,
  }
}
